import Availability from "app/models/availability"
import { Action, Types } from "./templateAvailabilities.actions"

export type Params = {
  sort?: string[]
  functions: string[]
  from: string
  to: string
  weekday: number
  workstationId: string
}

export type TemplateAvailabilitiesState = {
  data: Availability[]
  errors: {}
  loading: boolean
  params?: Params
}

const initialState: TemplateAvailabilitiesState = {
  data: [],
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): TemplateAvailabilitiesState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        data: [],
        params: action.payload.params,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload?.data || [],
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.RESET_PARAMS:
      return {
        ...state,
        loading: false,
        params: undefined,
      }

    default:
      return state
  }
}
